import type { ReactNode } from 'react'

import { Button } from '@/src/elements/button/default'
import { Card, CardBody, CardFooter, CardHeader } from '@/src/elements/card'
import { Typography } from '@/src/elements/text/Typography'
import { TEST_ID } from '@/src/general/constants/testId'
import { ICON } from '@/src/general/enums/icons'
import { TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'
import { useTranslate } from '@/src/lang/useTranslate'

import type { TPublicationToShare } from '../../../components/PublicationShareModal'
import { useSharePublication } from '../../../hooks/useSharePublication'

export const PublicationShareCardOnReward = ({ publication }: { publication: TPublicationToShare }): ReactNode => {
  const { t } = useTranslate()

  const { share } = useSharePublication()

  return (
    <Card
      className="mx-auto w-full max-w-[500px] gap-4 bg-secondary-bg-medium p-6"
      shadow="none"
      testID={TEST_ID.PUBLICATION.REWARD.SHARE_CARD.DEFAULT}
    >
      <CardHeader className="p-0">
        <Typography colors="secondary" bold size="lg">
          {t('publication.prayed.share.title')}
        </Typography>
      </CardHeader>

      <CardBody className="p-0">
        <Typography colors="secondary" contrast="high">
          {t('publication.prayed.share.body')}
        </Typography>
      </CardBody>

      <CardFooter className=" p-0">
        <Button
          variant="solid"
          colors="secondary"
          fullWidth
          startIcon={ICON.SEND}
          testID={TEST_ID.PUBLICATION.REWARD.SHARE_CARD.BUTTON}
          onPress={() => share(publication, TRACKING_SOURCE.INTENTION_POSTPUBCTA)}
        >
          {t('publication.prayed.share.button')}
        </Button>
      </CardFooter>
    </Card>
  )
}
